/**
 * External dependencies
 */

import { get } from 'lodash';


/**
 * Returns whether a section has a sidebar.
 *
 * @param  {Object}  state Global state tree
 * @return {Boolean} whether a section has a sidebar
 */
export function hasSidebar( state ) {
    return state.ui.hasSidebar;
}

/**
 * Returns whether a section is loading.
 *
 * @param  {Object}  state Global state tree
 * @return {Boolean}       Whether the section is loading
 */
export function isSectionLoading( state ) {
	return state.ui.isLoading;
}

/**
 * Returns the current section.
 *
 * @param  {Object}  state Global state tree
 * @return {Object}        Current section
 */
export function getSection( state ) {
    return state.ui.section || false;
}


/**
 * Returns the current section name.
 *
 * @param  {Object}  state Global state tree
 * @return {?String}       Current section name
 */
export function getSectionName( state ) {
    return get( getSection( state ), 'name', null );
}

export const isModalVisible = (name) => (state) => get(state, ['ui', 'modal', name, 'isVisible'], false);